import React from 'react'

import type { ICssIconProps } from '@/components/CssIcon'

export interface PlayIconProps
  extends Pick<
    ICssIconProps,
    'className' | 'containerClassName' | 'onClick' | 'containerProps'
  > {
  playing: boolean
  loading?: boolean
  playingIcon?: string
  pausedIcon?: string
  loadingIcon?: string
}

export default function PlayIcon(props: PlayIconProps) {
  const {
    playing,
    loading,
    className,
    playingIcon = cls`i-cus--tad-play-mobile`,
    pausedIcon = cls`i-com--pause`,
    loadingIcon = cls`i-com--loading animate-spin`,
    ...restProps
  } = props

  const stateIcon = useMemo(() => {
    if (loading) {
      return loadingIcon
    }
    return playing ? pausedIcon : playingIcon
  }, [loading, loadingIcon, pausedIcon, playing, playingIcon])

  return (
    <CssIcon
      className={cls`
        ${!restProps.containerClassName && `cursor-pointer`}
        ${stateIcon}
        ${className}
      `}
      {...restProps}
    />
  )
}
